/**
 * CancerScreeningAPI
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { CancerScreeningResultModel } from "./cancerScreeningResultModel";

export class GetCancerScreeningResultModel {

  cancerScreening?: CancerScreeningResultModel;

  constructor(i: any) {
    this.cancerScreening = i.cancerScreening
      ? new CancerScreeningResultModel(i.cancerScreening)
      : {};
  }
}

export class GetCancerScreeningResultWithQueryModel {
  cancerScreening: CancerScreeningResultModel;
  hpvTestResult?: HpvTestResult;
  pathologyTestResult?: PathologyTestResult;

  constructor(i: any) {
    this.cancerScreening = i.cancerScreeningWithResults
      ? new CancerScreeningResultModel(i.cancerScreeningWithResults)
      : {};
    this.hpvTestResult = i?.cancerScreeningWithResults?.hpvTestResult
      ? new HpvTestResult(
        i.cancerScreeningWithResults.hpvTestResult,
        i.cancerScreeningWithResults?.hpvTestCreateDate,
        i.cancerScreeningWithResults?.hpvTestRequestedByName
      )
      : i?.cancerScreeningWithResults?.hpvTestCreateDate
        ? new HpvTestResult(undefined, i.cancerScreeningWithResults?.hpvTestCreateDate, i.cancerScreeningWithResults?.hpvTestRequestedByName) : undefined;
    this.pathologyTestResult = i?.cancerScreeningWithResults
      ?.pathologyTestResult
      ? new PathologyTestResult(
        i.cancerScreeningWithResults.pathologyTestResult,
        i.cancerScreeningWithResults?.pathologyTestCreateDate,
        i.cancerScreeningWithResults?.pathologyTestRequestedByName
      )
      : i?.cancerScreeningWithResults?.pathologyTestCreateDate
        ? new PathologyTestResult(undefined, i.cancerScreeningWithResults?.pathologyTestCreateDate, i.cancerScreeningWithResults?.pathologyTestRequestedByName) : undefined;;
  }
}

export class HpvTestResult {
  createdDate?: string;
  hpvTestRequestedByName: string;
  conclusionNote: string;
  conclusionDate?: string;
  specimenArrivalDate?: string;
  codes?: HpvTestResultCode[];

  constructor(i: any, createdDate: string | undefined, hpvTestRequestedByName: string | undefined) {
    this.createdDate = createdDate;
    this.hpvTestRequestedByName = hpvTestRequestedByName ?? "";
    this.conclusionNote = i?.conclusionNote ? i.conclusionNote : "";
    this.conclusionDate = i?.conclusionDate ? i.conclusionDate : undefined;
    this.specimenArrivalDate = i?.specimenArrivalDate
      ? i.specimenArrivalDate
      : undefined;
    this.codes = i?.codes
      ? i.codes.map((item: any) => new HpvTestResultCode(item))
      : undefined;
  }
}

export class PathologyTestResult {
  createdDate?: string;
  pathologyTestRequestedByName: string;
  conclusionNote: string;
  conclusionDate?: string;
  specimenArrivalDate?: string;
  details?: PathologyTestResultDetails[];

  constructor(i: any, createdDate: string | undefined, pathologyTestRequestedByName: string | undefined) {
    this.createdDate = createdDate;
    this.pathologyTestRequestedByName = pathologyTestRequestedByName ?? "";
    this.conclusionNote = i?.conclusionNote ? i.conclusionNote : "";
    this.conclusionDate = i?.conclusionDate ? i.conclusionDate : undefined;
    this.specimenArrivalDate = i?.specimenArrivalDate
      ? i.specimenArrivalDate
      : undefined;
    this.details = i?.details
      ? i.details.map((item: any) => new PathologyTestResultDetails(item))
      : undefined;
  }
}

export class HpvTestResultCode {
  code: string;
  status: string;

  constructor(i: any) {
    this.code = i?.code ? i.code : "";
    this.status = i?.status ? i.status : "";
  }
}

export class PathologyTestResultDetails {
  code: string;
  description: string;

  constructor(i: any) {
    this.code = i?.code ? i.code : "";
    this.description = i?.description ? i.description : "";
  }
}
